export default "__VITE_ASSET__CQHBLSFB__"